import * as z from "zod/v4";

export const moveFulfillmentGroupToTotes = {
  name: "moveFulfillmentGroupToTotes" as const,
  input: z.object({
    fulfillmentGroupId: z.string(),
    toteIds: z.array(z.string()),
  }),
  output: z.object({
    success: z.boolean(),
    message: z.string().optional(),
  }),
};
